import React, { useEffect, useReducer, useState } from 'react';
import { Box, Typography, Loader, Button } from '@strapi/design-system';
import { Coordinates, Location } from '../../../../types';
import { isSamePoint, isValidPoint, noPoint } from '../../utils/input';
import { useIntl } from 'react-intl';
import useConfig from '../../hooks/useConfig';
import { Marker } from '@react-google-maps/api';
import { ArrowClockwise } from '@strapi/icons';
import Geohash from 'latlon-geohash';
import { MapInstance } from './MapView';
import GoogleMapsProvider from './GoogleMapsProvider';
import NumberFields from './CoordsInput';
import { useAuth } from '@strapi/strapi/admin';

export default function Input(data: any) {

    console.log('data', data)


    const { formatMessage } = useIntl();

    const token = useAuth('ConfigurationProvider', (state) => state.token);

    const config = useConfig();

    const [focusPoint, setFocusPoint] = useState<Coordinates | undefined>();

    const [currentPoint, setCurrentPoint] = useReducer(
        (state: Coordinates, action: any) => {
            const { origin, value } = action;

            if (
                (origin === 'coordsInput' ||
                    origin === 'placeSearch' ||
                    origin === 'fieldValue') &&
                isValidPoint(value) &&
                !isSamePoint(state, value)
            ) {
                setFocusPoint(value);
            }

            return value;
        },
        noPoint
    );

    const [currentAddress, setCurrentAddress] = useState('');

    const [nothingSelectedWarning, setNothingSelectedWarning] = useState(false);

    useEffect(() => {
        if (data.required && !isValidPoint(currentPoint)) {
            setNothingSelectedWarning(true);
        } else if (nothingSelectedWarning) {
            setNothingSelectedWarning(false);
        }
    }, [currentPoint]);

    useEffect(() => {
        const newValue: string | null = isValidPoint(currentPoint)
            ? JSON.stringify({
                address: currentAddress,
                coordinates: currentPoint,
                geohash: Geohash.encode(currentPoint.lat, currentPoint.lng),
            })
            : null;

        data.onChange({
            target: {
                name,
                value: newValue,
                type: data.attribute.type, // json
            },
        });
    }, [currentPoint, currentAddress]);

    useEffect(() => {
        if (!data.value) return;

        let parsedValue: Location = data.value;

        if (typeof data.value === 'string') {
            parsedValue = JSON.parse(data.value);
        }

        if (!parsedValue) return;

        const { address, coordinates } = parsedValue;

        if (address === currentAddress && isSamePoint(currentPoint, coordinates))
            return;

        setCurrentPoint({ origin: 'fieldValue', value: coordinates });
        setCurrentAddress(address);
    }, [data.value]);

    const onReset = () => {
        setCurrentPoint({ origin: 'reset', value: noPoint });

        setCurrentAddress('');
    };

    return (
        <>
            <Typography variant='pi' fontWeight='bold'>
                {formatMessage({
                    id: 'input.label',
                })}
            </Typography>

            {!config && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Loader small />
                </div>
            )}

            {!!config && (
                <>
                    <Box
                        marginTop={1}
                        borderColor={nothingSelectedWarning ? 'danger600' : 'primary200'}
                    >
                        {console.log('data.name', data.name)}
                        {data.name &&
                            <GoogleMapsProvider id={data.name} config={config}>
                                <MapInstance
                                    name={data.name}
                                    focusPoint={focusPoint}
                                    currentAddress={currentAddress}
                                    onCoordsChange={setCurrentPoint}
                                    onAddressChange={setCurrentAddress}
                                >
                                    {isValidPoint(currentPoint) && <Marker position={currentPoint} />}
                                </MapInstance>
                            </GoogleMapsProvider>

                        }

                    </Box>

                    {nothingSelectedWarning && (
                        <Box paddingTop={1}>
                            <Typography variant='pi' textColor='danger600'>
                                {formatMessage({
                                    id: 'input.error.required',
                                })}
                            </Typography>
                        </Box>
                    )}

                    <Box paddingTop={2}>
                        <NumberFields
                            coords={currentPoint}
                            onChange={(point) =>
                                setCurrentPoint({ origin: 'coordsInput', value: point })
                            }
                        />
                    </Box>

                    <Box paddingTop={2}>
                        <Button startIcon={<ArrowClockwise />} onClick={onReset}>
                            {formatMessage({
                                id: 'input.button.reset',
                            })}
                        </Button>
                    </Box>
                </>
            )}
        </>
    );
}